var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Test")]),_c('p',[_vm._v("Test")]),_c('iframe',{ref:"testukas",attrs:{"src":"","frameborder":"0"}})])}
var staticRenderFns = []

export { render, staticRenderFns }